import ButtonController from '../../../components/containers/buttonController';
import { chartReportConfigs } from '../../../utils/config/chartReportConfig';
import DynamicTable from '../../../components/tables/dynamicTable';
import { useReportData } from '../../../hooks/data/useReportData';
import { useChart } from '../../../hooks/reports/useReportChart';
import Toggle from '../../../components/common/ToggleButton';
import Sidebar from '../../../components/sidebar/Sidebar';
import NavBar from '../../../components/navbar/NavBar';
import { useLocation } from 'react-router-dom';
import { useState } from 'react';
import './togglereport.css';

const ToggleReport = () => {
  const location = useLocation();
  const { reportName, reportId } = location.state || {};

  const [tableSelection, setTableSelection] = useState("Table Data");
  const toggleObject = { tableSelection: tableSelection, toggleButtons: ["Table Data", "Chart"] };

  const config = chartReportConfigs[reportName];
  const report = tableSelection === "Table Data" ? reportName : config.chartSource;
  const { data } = useReportData(report, 250);
  const chart = useChart(config, data);  

  return (
    <div className='toggleReportPage'>
      <div className="LandingPageContainer">
        <NavBar />
        <Sidebar />
        <div className="tableReportsPageContent">
          <div className="toggleReportTitle"><h1>{reportName}</h1></div>
          <div className="toggleReportSettings">
            <Toggle toggleValue={setTableSelection} toggleObject={toggleObject} />
          </div>
          <div className="tableReportsSpace">
            {tableSelection === "Table Data" && (
              <div className="report">
                <DynamicTable dataObject={data} />
                <div className="tabledReportRight">
                  <ButtonController reportName={reportName}  onDownloadClick={() => data.data}/>
                </div>
              </div>
            )}
            {tableSelection === "Chart" && (
              <div className="toggleChart">
                {chart}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default ToggleReport